<div class="title">Tags</div>

<div class="block">
  <div class="subtitle">Business tags</div>

  <table>
    {#each companyTags as tag}
      <tr>
        <td>{tag}</td>
      </tr>
    {/each}
  </table>

  <button class="button" on:click={syncBusinessTags}>Sync</button>

  <hr />
</div>

<div class="block">
  <div class="subtitle">Charity tags</div>

  <table>
    {#each charityTags as tag}
      <tr>
        <td>{tag}</td>
      </tr>
    {/each}
  </table>

  <button class="button" on:click={syncCharityTags}>Sync</button>

  <hr />
</div>

<div class="block">
  <div class="subtitle">Offer tags</div>

  <table>
    {#each offerTags as tag}
      <tr>
        <td>{tag}</td>
      </tr>
    {/each}
  </table>

  <button class="button" on:click={syncOfferTags}>Sync</button>

  <hr />
</div>

<script lang="ts">
  let companyTags: string[] = [];
  let charityTags: string[] = [];
  let offerTags: string[] = [];

  updateTags();

  async function updateTags() {
    companyTags = await getTags('company');
    charityTags = await getTags('charity');
    offerTags = await getTags('offer');
  }

  async function getTags(type: string) {
    return (
      await window.firebase.firestore().collection(`tags_v1/${type}/tags`).get()
    ).docs.map((doc) => doc.id);
  }

  async function syncBusinessTags() {
    await syncTags('company');
    companyTags = await getTags('company');
  }

  async function syncCharityTags() {
    await syncTags('charity');
    charityTags = await getTags('charity');
  }

  async function syncOfferTags() {
    await syncTags('offer');
    offerTags = await getTags('offer');
  }

  async function syncTags(type: string) {

    const collectionName = {
      'company': 'companies_v1',
      'charity': 'charities_v2',
      'offer': 'offers_v2'
    }[type];

    await window.firebase
      .functions()
      .httpsCallable('api-util-deleteDocRecursive')({
      path: `tags_v1/${type}`
    } as DeleteDocRecursiveParams);

    const promises : any[] = [];

    const objects = await window.firebase
      .firestore()
      .collection(collectionName!)
      .get();

      objects.forEach((object) => {
        object.data().tags?.forEach(async (tag: string) => {
          promises.push(storeTag(tag));
      });
    });

    await Promise.all(promises);

    async function storeTag(tag: string) {
      if (tag.indexOf(':') > -1) {
          const name = tag.split(':')[0];
          const value = tag.split(':')[1];
          await window.firebase
            .firestore()
            .collection(`tags_v1/${type}/tags`)
            .doc(name + ':')
            .set({ flag: true });
          await window.firebase
            .firestore()
            .collection(`tags_v1/${type}/tags/${name + ':'}/values`)
            .doc(value)
            .set({ flag: true });
        } else {
          await window.firebase
            .firestore()
            .collection(`tags_v1/${type}/tags`)
            .doc(tag)
            .set({ flag: true });
        }
    }
  }
</script>
